export default __webpack_public_path__ + "static/media/eventsIcon.25a97141.svg";